module.exports = __webpack_public_path__ + "img/拼一拼.b2ed8a36.png";